module.exports = __webpack_public_path__ + "static/img/footer@2x.8715fb03.png";